import { css } from 'styled-components';
import { COLORS } from '../../config/theme';

const style = () => css`
    .payments-stats-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin-bottom: 16px;
        flex-wrap: wrap;

        .payments-stats-title {
            color: ${(props) => props.theme[COLORS.PRIMARY_TEXT]};
            font-size: 24px;
            font-weight: 700;
        }

        .ant-picker-range {
            border-radius: 5px;
        }
    }

    .payments-summary-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        gap: 12px;
        margin-bottom: 16px;
        position: relative;
    }

    .payments-summary-card {
        background: ${(props) => props.theme[COLORS.WHITE]};
        border-radius: 5px;
        padding: 16px;
    }

    .payments-summary-card-label {
        color: ${(props) => props.theme[COLORS.ICONS]};
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
    }

    .payments-summary-card-value {
        color: ${(props) => props.theme[COLORS.PRIMARY_TEXT]};
        font-size: 24px;
        font-weight: 800;
        line-height: 1;
        margin-top: 8px;
    }

    .payments-summary-card-trend {
        color: ${(props) => props.theme[COLORS.ICONS]};
        font-size: 13px;
        font-weight: 700;
        margin-top: 8px;

        &.up {
            color: ${(props) => props.theme[COLORS.SUCCESS]};
        }

        &.down {
            color: ${(props) => props.theme[COLORS.DECLINED]};
        }
    }

    .payments-stats-loading {
        align-items: center;
        background: rgba(255, 255, 255, 0.65);
        border-radius: 5px;
        bottom: 0;
        display: flex;
        justify-content: center;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
    }

    .ant-input-affix-wrapper {
        height: 40px;
        border-radius: 12px;
        width: 100%;
        max-width: 350px;

        .ant-input-prefix {
            margin-right: 6px;
        }
    }
    .ant-tabs-tab {
        border-radius: 5px !important;
    }
    .ant-table {
        box-shadow: ${(props) => props.theme[COLORS.CARD_SHADOW]};
        border-radius: 15px;
        overflow: hidden;
        margin-top: 10px;
        .ant-table-thead > tr > th {
            font-weight: 600;
        }
    }

    @media (max-width: 768px) {
        .payments-stats-header {
            align-items: flex-start;
            flex-direction: column;
        }

        .payments-stats-header .ant-picker {
            width: 100%;
        }
    }
`;

export default style();
